module.exports = __webpack_public_path__ + "static/media/humildade.da6c731d.jpg";